export default __webpack_public_path__ + "static/media/comercio_15.f28efb98.png";